import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import styles from './styles.scss';

const MyExamTile = (props) => {
  const {
    title,
    score,
    scoreInfo,
    when,
    cta,
  } = props;

  const {
    text: ctaText,
    type: ctaType,
    ...ctaRest
  } = cta;

  return (
    <div className={styles.tile}>
      <div className={styles.tileTitle}>{title}</div>
      <div className={styles.tileLength}>{when}</div>
      <div className={styles.score}>
        {score}
      </div>
      {scoreInfo && <div className={styles.scoreInfo}>{scoreInfo}</div>}
      <div className={styles.tileCta}>
        <Link {...ctaRest}>
          <Button type={ctaType}>{ctaText}</Button>
        </Link>
      </div>
    </div>
  );
};

export default MyExamTile;
